import blowout1 from "../Images/Hairstyles/malestyles/blowout1.jpeg";
import blowout2 from "../Images/Hairstyles/malestyles/blowout2.jpeg";
import blowout3 from "../Images/Hairstyles/malestyles/blowout3.jpeg";
import blowout4 from "../Images/Hairstyles/malestyles/blowout4.jpeg";
import blowout5 from "../Images/Hairstyles/malestyles/blowout5.jpeg";
import blowout6 from "../Images/Hairstyles/malestyles/blowout6.jpeg";
import blowout7 from "../Images/Hairstyles/malestyles/blowout7.jpeg";
import blowout8 from "../Images/Hairstyles/malestyles/blowout8.jpeg";
import blowout9 from "../Images/Hairstyles/malestyles/blowout9.jpeg";
import blowout10 from "../Images/Hairstyles/malestyles/blowout10.jpeg";
import boxBraid1 from "../Images/Hairstyles/malestyles/boxbraids1.jpeg";
import boxBraid2 from "../Images/Hairstyles/malestyles/boxbraids2.jpeg";
import boxBraid3 from "../Images/Hairstyles/malestyles/boxbraids3.jpeg";
import boxBraid4 from "../Images/Hairstyles/malestyles/boxbraids4.jpeg";
import boxBraid5 from "../Images/Hairstyles/malestyles/boxbraids5.jpeg";
import boxBraid6 from "../Images/Hairstyles/malestyles/boxbraids6.jpeg";
import boxBraid7 from "../Images/Hairstyles/malestyles/boxbraids7.jpeg";
import boxBraid8 from "../Images/Hairstyles/malestyles/boxbraids8.jpeg";
import boxBraid9 from "../Images/Hairstyles/malestyles/boxbraids9.jpeg";
import boxBraid10 from "../Images/Hairstyles/malestyles/boxbraids10.jpeg";
import cornrow1 from "../Images/Hairstyles/malestyles/cornrow1.jpeg";
import cornrow2 from "../Images/Hairstyles/malestyles/cornrow2.jpeg";
import cornrow3 from "../Images/Hairstyles/malestyles/cornrow3.jpeg";
import cornrow4 from "../Images/Hairstyles/malestyles/cornrow4.jpeg";
import cornrow5 from "../Images/Hairstyles/malestyles/cornrow5.jpeg";
import cornrow6 from "../Images/Hairstyles/malestyles/cornrow6.jpeg";
import cornrow7 from "../Images/Hairstyles/malestyles/cornrow7.jpeg";
import cornrow8 from "../Images/Hairstyles/malestyles/cornrow8.jpeg";
import cornrow9 from "../Images/Hairstyles/malestyles/cornrow9.jpeg";
import cornrow10 from "../Images/Hairstyles/malestyles/cornrow10.jpeg";
import dread1 from "../Images/Hairstyles/malestyles/dread1.jpeg";
import dread2 from "../Images/Hairstyles/malestyles/dread2.jpeg";
import dread3 from "../Images/Hairstyles/malestyles/dread3.jpeg";
import dread4 from "../Images/Hairstyles/malestyles/dread4.jpeg";
import dread5 from "../Images/Hairstyles/malestyles/dread5.jpeg";
import dread6 from "../Images/Hairstyles/malestyles/dread6.jpeg";
import dread7 from "../Images/Hairstyles/malestyles/dread7.jpeg";
import dread8 from "../Images/Hairstyles/malestyles/dread8.jpeg";
import dread9 from "../Images/Hairstyles/malestyles/dread9.jpeg";
import dread10 from "../Images/Hairstyles/malestyles/dread10.jpeg";
import fringe1 from "../Images/Hairstyles/malestyles/fringe1.jpeg";
import fringe2 from "../Images/Hairstyles/malestyles/fringe2.jpeg";
import fringe3 from "../Images/Hairstyles/malestyles/fringe3.jpeg";
import fringe4 from "../Images/Hairstyles/malestyles/fringe4.jpeg";
import fringe5 from "../Images/Hairstyles/malestyles/fringe5.jpeg";
import fringe6 from "../Images/Hairstyles/malestyles/fringe6.jpeg";
import fringe7 from "../Images/Hairstyles/malestyles/fringe7.jpeg";

export const maleHairstyle = [
  {
    id: 1,
    image: blowout1,
    name: "Blowout with side cut",
    price: 3230,
    duration: 60,
    attachments: false,
    trending: true,
    category: "Blowout",
    popular: false,
  },
  {
    id: 41,
    name: "Fringe",
    price: 5970,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Fringe",
    image: fringe4,
  },
  {
    id: 14,
    name: "Short Box Braids",
    price: 5970,
    duration: 240,
    popular: false,
    attachments: true,
    trending: true,
    category: "Box Braids",
    image: boxBraid4,
  },
  {
    id: 4,
    name: "Blowout with Side split",
    price: 4970,
    popular: false,
    duration: 40,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout4,
  },
  {
    id: 5,
    name: "All round Blowout",
    popular: false,
    price: 4390,
    duration: 30,
    attachments: false,
    trending: true,
    category: "Blowout",
    image: blowout5,
  },
  {
    id: 40,
    name: "Curly Fringe",
    price: 45040,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Fringe",
    image: fringe3,
  },
  {
    id: 7,
    name: "Blowout ",
    price: 6687,
    duration: 70,
    popular: false,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout7,
  },
  {
    id: 27,
    name: "Cornrow",
    popular: false,
    price: 6687,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow10,
  },
  {
    id: 2,
    name: "Long Afro",
    price: 2530,
    duration: 60,
    attachments: false,
    trending: false,
    image: blowout2,
    category: "Blowout",
    popular: false,
  },
  {
    id: 8,
    name: "Smooth Blowout ",
    price: 5364,
    popular: false,
    duration: 1,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout8,
  },
  {
    id: 10,
    name: "Side Shave Blowout",
    price: 5486,
    popular: false,
    duration: 40,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout10,
  },
  {
    id: 11,
    image: boxBraid1,
    name: "Long Braids",
    price: 5987,
    duration: 180,
    attachments: true,
    trending: true,
    popular: false,
    category: "Box Braids",
  },
  {
    id: 12,
    name: "Short Box Braids",
    price: 6530,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    image: boxBraid2,
    category: "Box Braids",
  },
  {
    id: 13,
    name: "Short  Braids",
    price: 45040,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Box Braids",
    popular: true,
    image: boxBraid3,
  },
  {
    id: 6,
    name: "Short Blowout",
    price: 5489,
    popular: false,
    duration: 60,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout6,
  },
  {
    id: 15,
    name: "Tiny Braids",
    price: 4390,
    popular: false,
    duration: 180,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid5,
  },
  {
    id: 31,
    name: "All Side Dread",
    price: 5970,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Dread",
    image: dread4,
  },
  {
    id: 17,
    name: "Short Braids",
    price: 5687,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid7,
  },
  {
    id: 19,
    name: "Side Part Cornrow",
    price: 4530,
    duration: 180,
    attachments: true,
    trending: false,
    popular: false,
    image: cornrow2,
    category: "Cornrow",
  },
  {
    id: 20,
    name: "Big Cornrow",
    price: 35040,
    duration: 120,
    attachments: true,
    trending: false,
    popular: false,
    category: "Cornrow",
    image: cornrow3,
  },
  {
    id: 21,
    name: "Crossed Cornrow",
    price: 4970,
    duration: 180,
    popular: false,
    attachments: true,
    trending: true,
    category: "Cornrow",
    image: cornrow4,
  },
  {
    id: 22,
    name: "Interlocked Cornrow ",
    price: 4390,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow5,
  },
  {
    id: 23,
    name: "All-back Cornrow",
    price: 5489,
    duration: 240,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow6,
  },
  {
    id: 9,
    name: " Round Blowout",
    price: 6532,
    duration: 50,
    popular: false,
    attachments: false,
    trending: false,
    category: "Blowout",
    image: blowout9,
  },
  {
    id: 25,
    name: "Web Cornrow",
    price: 5687,
    popular: true,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow8,
  },
  {
    id: 26,
    name: "Big Cornrow",
    price: 6687,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Cornrow",
    image: cornrow9,
  },
  {
    id: 3,
    name: "Blowout",
    price: 45040,
    duration: 30,
    attachments: false,
    trending: false,
    category: "Blowout",
    popular: false,
    image: blowout3,
  },
  {
    id: 28,
    image: dread1,
    popular: false,
    name: "Short Scattered Dreads",
    price: 5230,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Dread",
  },
  {
    id: 29,
    name: "Long Dread",
    price: 5530,
    duration: 240,
    attachments: true,
    trending: true,
    image: dread2,
    popular: false,
    category: "Dread",
  },
  {
    id: 30,
    name: "Short Dread",
    price: 45040,
    popular: false,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread3,
  },
  {
    id: 16,
    name: "Side Cut Braids",
    popular: false,
    price: 5489,
    duration: 180,
    attachments: true,
    trending: false,
    category: "Box Braids",
    image: boxBraid6,
  },
  {
    id: 32,
    name: "Long Dread",
    price: 4390,
    duration: 240,
    popular: false,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread5,
  },
  {
    id: 33,
    name: "Shoulder Length Dread",
    price: 5489,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Dread",
    popular: false,
    image: dread6,
  },
  {
    id: 34,
    name: "Cornrowed  Dread",
    price: 6687,
    duration: 300,
    attachments: true,
    popular: true,
    trending: false,
    category: "Dread",
    image: dread7,
  },
  {
    id: 35,
    name: "Long Dread with Twists",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    category: "Dread",
    image: dread8,
    popular: true,
  },
  {
    id: 36,
    name: "Side Split Short Dread",
    price: 6687,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Dread",
    image: dread10,
  },
  {
    id: 37,
    name: "Crossed Dread",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    popular: false,
    category: "Dread",
    image: dread9,
  },
  {
    id: 38,
    image: fringe1,
    name: "Long Fringe",
    price: 5230,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Fringe",
  },
  {
    id: 18,
    image: cornrow1,
    name: "Half Braid with Cornrow",
    price: 3230,
    duration: 180,
    popular: false,
    attachments: true,
    trending: true,
    category: "Cornrow",
  },
  {
    id: 39,
    name: "Side Fringe",
    price: 5530,
    duration: 240,
    attachments: true,
    trending: false,
    image: fringe2,
    category: "Fringe",
    popular: false,
  },
  {
    id: 24,
    name: "Cornrow with Braid",
    price: 6687,
    duration: 70,
    attachments: true,
    popular: false,
    trending: false,
    category: "Cornrow",
    image: cornrow7,
  },
  {
    id: 42,
    name: "Short Fringe",
    price: 4390,
    duration: 240,
    attachments: true,
    trending: false,
    category: "Fringe",
    popular: false,
    image: fringe5,
  },
  {
    id: 43,
    name: "Side Split Fringe",
    price: 5489,
    popular: false,
    duration: 240,
    attachments: true,
    trending: true,
    category: "Fringe",
    image: fringe6,
  },
  {
    id: 44,
    name: "Bowl Fringe",
    price: 6687,
    duration: 300,
    attachments: true,
    trending: false,
    category: "Fringe",
    image: fringe7,
  },
  {
    id: 45,
    name: "Long Braids",
    price: 3687,
    duration: 300,
    attachments: true,
    trending: false,
    popular: false,
    category: "Box Braids",
    image: boxBraid8,
  },
  {
    id: 46,
    name: " Long Box Braids",
    price: 6687,
    duration: 240,
    attachments: true,
    trending: false,
    popular: false,
    category: "Box Braids",
    image: boxBraid9,
  },
  {
    id: 47,
    name: "Long Cornrow Braids",
    price: 4687,
    duration: 300,
    attachments: true,
    trending: true,
    category: "Box Braids",
    popular: false,
    image: boxBraid10,
  },
];
